import React from 'react';

import { Input, Select, Switch } from 'antd';

import styled from 'styled-components';

import { useStateValue } from '@contexts/StateProvider';

import useNwBreakPoints from '@hooks/Layout/UseNwBreakPoints';

import {
    useContactsSelector,
    useContactsSelectorDispatch,
} from '@components/ContactsSelector/Common/ContactsSelectorContext';
import MiniLoading from '@components/Gui/MiniLoading';
import RadioButtonGroup from '@components/Gui/NwForm/RadioButtonGroup';
import NwIcon from '@components/Gui/NwIcon';

import { byPrefixAndName } from '@awesome.me/kit-d6dae216cd/icons';

const StyledHeader = styled.div`
    margin: 0;
    padding: 0;
    position: relative;
    background: #fff;
    border-radius: 6px;
    border: 1px solid #f0f0f0;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: flex-start;
    padding: 1em 2em;
    font-size: 0.9rem;

    @media (max-width: 480px) {
        border-radius: 0;
    }

    @media only screen and (max-width: 960px) {
        flex-direction: column;
        align-items: flex-start;
        justify-content: flex-start;
    }

    .header-summary {
        border-right: 1px solid #e8e8e8;
        flex: auto 0 0;
        padding: 0 1em 0 0;

        @media only screen and (max-width: 960px) {
            border-right: none;
            padding: 0;
        }

        .header-summary-text {
            font-size: 1em;
            display: flex;
            align-items: center;

            em.counter {
                font-size: 1.6em;
                font-weight: bold;
                font-style: normal;
                padding-right: 0.5em;
            }
        }
        small.hidden-models {
            display: block;
        }
    }

    .header-filters {
        // border-right: 1px solid #e8e8e8;
        display: flex;
        flex-direction: row;
        flex: 1 0 0;
        padding: 0 1em 0 1em;
        margin-bottom: auto;

        @media only screen and (max-width: 960px) {
            flex-direction: column;
            padding: 0;
            flex: none;
            align-items: flex-start;
        }

        .header-filters-first-row,
        .header-filters-second-row {
            .control {
                padding-right: 1em;
            }

            @media only screen and (max-width: 640px) {
                flex-direction: column;
                align-items: flex-start;
                padding: 0;
            }
        }
    }

    .header-actions {
        display: flex;
        flex-direction: row;
        margin-bottom: auto;
        flex: auto 0 0;
        padding: 0 0 0 1em;

        @media only screen and (max-width: 960px) {
            flex-direction: column;
            padding: 0;
            min-width: 0;
        }
    }

    div.control {
        padding: 0.5em 0;
        span.label {
            font-size: 0.85em;
            text-transform: uppercase;
            padding: 0 0.5em 0 0;

            &.on-right {
                padding: 0 0 0 0.5em;
            }
        }
    }
`;

const ModelsWallAccountingHeader = ({
    //beforeChangeSort,
    isLoading,
    modelList,
}) => {
    const [{ areaContext }] = useStateValue();
    const breakpoints = useNwBreakPoints();
    const isMobile = breakpoints === 1;

    const nItems = modelList ? modelList.length : 0;

    const { layout, selection, actions } = useContactsSelector();

    const { listType, quickFilters } = selection;
    const { multipleSelection, multipleSelectionActive } = actions;
    const { view } = layout;

    const cs_dispatch = useContactsSelectorDispatch();

    const onChangeListSort = (key) => {
        //beforeChangeSort()
        cs_dispatch({
            type: 'ChangeQuickFilters',
            quickFilters: { ...quickFilters, sort: key },
        });
    };

    const handleChangeFilter = (name, value) => {
        cs_dispatch({
            type: 'ChangeQuickFilters',
            quickFilters: {
                ...quickFilters,
                [name]: value,
            },
        });
        // if (onAfterChangeFilters) {
        //     onAfterChangeFilters()
        // }
    };

    // const onChangeListSortFolder = (key) => {
    //     beforeChangeSort();
    //     cs_dispatch({
    //         type: 'ChangeQuickFilters',
    //         quickFilters: { ...quickFilters, sortFolder: key },
    //     });
    // };

    const toggleMultipleSelection = (value) => {
        cs_dispatch({
            type: 'ToggleMultipleSelection',
            value: value,
        });
    };

    // let sortOptionsFolder = [
    //     { label: 'Name', value: 'Name' },
    //     { label: 'Manual', value: 'Manual' }
    // ];
    let sortOptions = [
        { label: 'Name', value: 'Name' },
        { label: 'ID', value: 'ID' },
        { label: 'Mother Agency', value: 'MotherAgency' },
        { label: 'In Agency Since', value: 'InAgencyFrom' },
    ];

    return (
        <>
            <StyledHeader>
                {isMobile ? (
                    !isLoading ? (
                        <>
                            <div className="mobile-header-summary">
                                <div className="header-summary-text">
                                    <em className="counter">{nItems}</em> MODELS FOUND
                                </div>
                            </div>
                        </>
                    ) : (
                        <div className="loading-container">
                            <MiniLoading />
                        </div>
                    )
                ) : (
                    <>
                        <div className="header-summary">
                            {!isLoading ? (
                                <>
                                    <div className="header-summary-text">
                                        <em className="counter">{nItems}</em> MODELS FOUND
                                    </div>
                                </>
                            ) : (
                                <>
                                    <div className="loading-container">
                                        <MiniLoading />
                                    </div>
                                    <p className="loading-title">Fetching Models...</p>
                                </>
                            )}
                        </div>
                        <div className="header-filters">
                            <div className="control">
                                <span className="label">sort by</span>
                                {breakpoints < 5 ? (
                                    <Select
                                        autoComplete="off"
                                        options={sortOptions}
                                        size="small"
                                        value={quickFilters.sort}
                                        onChange={onChangeListSort}
                                    />
                                ) : (
                                    <RadioButtonGroup
                                        value={quickFilters.sort}
                                        onChange={onChangeListSort}
                                        size="small"
                                        options={sortOptions}
                                    />
                                )}
                            </div>
                        </div>
                        <div className="header-filters">
                            <Input
                                allowClear
                                autoComplete="off"
                                placeholder="Filter by name"
                                prefix={<NwIcon icon={byPrefixAndName.fasl['search']} />}
                                onChange={(e) => {
                                    handleChangeFilter('nameFilter', e.target.value);
                                }}
                                value={quickFilters.nameFilter}
                            />
                        </div>
                        <div className="header-actions" style={{ flexDirection: layout.drawer && 'column' }}>
                            {multipleSelection && breakpoints !== 1 && (
                                <div className="control" style={{ marginRight: '10px' }}>
                                    <Switch checked={multipleSelectionActive} onChange={toggleMultipleSelection} />
                                    <span className="label on-right">select</span>
                                </div>
                            )}
                        </div>
                    </>
                )}
            </StyledHeader>
        </>
    );
};

export default ModelsWallAccountingHeader;
